module.exports = __webpack_public_path__ + "img/Hypoxia-ASHN_GSE227469.d40052a2.png";